import {Component, OnInit, QueryList, ViewChild, ViewChildren, Output, EventEmitter} from '@angular/core';
import * as moment from 'moment';
import { NegociosService, ProductoService, CosechaService, CategoriaService, EntregaService, NEGOCIO_TYPE_DISPO, NEGOCIO_TYPE_FORWARD, PreciosService  } from '../../../../services';
import { ChipsSelectorComponent } from '../../../common/chips-selector/chips-selector.component';
import { CuentaAutocompleteComponent } from '../../../common/autocomplete/cuenta-autocomplete/cuenta-autocomplete.component';
import { AcopioAutocompleteComponent } from '../../../common/autocomplete/acopio-autocomplete/acopio-autocomplete.component';
import {ColaboradorAutocompleteComponent} from '../../../common/autocomplete/colaborador-autocomplete/colaborador-autocomplete.component';
import {FUENTE_NAMES} from '@services/negocios-service';
@Component({
  selector: 'app-negocios-kanban-filters',
  templateUrl: './negocios-kanban-filters.component.html',
  styleUrls: ['./negocios-kanban-filters.component.scss']
})
export class NegociosKanbanFiltersComponent implements OnInit {

  @ViewChild('creacionDesdeDatePicker') creacionDesdeDatePicker;
  @ViewChild('creacionHastaDatePicker') creacionHastaDatePicker;
  @ViewChild('temporalDesdeDatePicker') temporalDesdeDatePicker;
  @ViewChild('temporalHastaDatePicker') temporalHastaDatePicker;
  @ViewChildren(ChipsSelectorComponent) chipFilters: QueryList<ChipsSelectorComponent>;
  @ViewChild(CuentaAutocompleteComponent) clienteAutocomplete;
  @ViewChild(AcopioAutocompleteComponent) acopioAutocomplete;
  @ViewChildren(ColaboradorAutocompleteComponent) colaboradoresAutocomplete: QueryList<ColaboradorAutocompleteComponent>;

  @Output() searchKanban = new EventEmitter<{}>();

  private CHIP_TYPES = {
    PRODUCTO: 'producto',
    ZONA: 'zona'
  };

  private FECHA = {
    CREACION_DESDE: 'CD',
    CREACION_HASTA: 'CH',
    TEMPORAL_DESDE: 'TD',
    TEMPORAL_HASTA: 'TH'
  };

  private NEGOCIO_TYPE_DISPO = NEGOCIO_TYPE_DISPO;
  private NEGOCIO_TYPE_FORWARD = NEGOCIO_TYPE_FORWARD;

  private endOfDay = moment().endOf('day').toDate();

  public filters: any;

  private tipoOptions = [];
  private productoOptions = [];
  private cosechaOptions = [];
  private entregaOptions = [];
  private posicionOptions = [];
  private pagoDiferidoExists = false;
  private negocioOptions = [];
  private currentEntregaOptions = [];
  private zonasOptions = [];
  private mercadoOptions = [];

  FUENTE_NAMES = FUENTE_NAMES;

  constructor(private negociosService: NegociosService,
              private productoService: ProductoService,
              private cosechaService: CosechaService,
              private entregaService: EntregaService,
              private categoriaService: CategoriaService,
              private preciosService: PreciosService,) {
    productoService.Options.subscribe(newValue => {
      this.productoOptions = newValue;
    });
    productoService.loadOptions();
    categoriaService.loadOptions();
    cosechaService.Options.subscribe(newValue => {
      this.cosechaOptions = newValue;
    });
    entregaService.Options.subscribe(newValue => {
      this.entregaOptions = newValue;
    });
    entregaService.PosicionOptions.subscribe(newValue => {
      this.posicionOptions = newValue;
      if (this.posicionOptions.length) {
        const filtered = this.posicionOptions.length ? this.posicionOptions.filter(x => x.Tipo === 'Posicion') : [];
        this.pagoDiferidoExists = filtered.length ? filtered[0].hasOwnProperty('Entrega_Id') : false;
        this.filters = this.negociosService.negocioKanbanFilter;
        this.setupNegocioOptions();
      }
    });
    categoriaService.Options.subscribe(newValue => {
      this.zonasOptions = newValue;
    });
    preciosService.getMercadosPizarra().subscribe(res => {
      this.mercadoOptions = res;
    });
  }

  ngOnInit() {
    this.filters = this.negociosService.negocioKanbanFilter;
    this.tipoOptions = this.negociosService.getTipoSelectOptions();
  }

  showDatePicker(picker) {
    switch (picker) {
      case this.FECHA.CREACION_DESDE:
        this.creacionDesdeDatePicker.open();
        break;
      case this.FECHA.CREACION_HASTA:
        this.creacionHastaDatePicker.open();
        break;
      case this.FECHA.TEMPORAL_DESDE:
        this.temporalDesdeDatePicker.open();
        break;
      case this.FECHA.TEMPORAL_HASTA:
        this.temporalHastaDatePicker.open();
        break;
    }
  }

  selectedDate(e, entity) {
    // estos filtros se cancelan entre si en el back por lo que se cancelan en el front
    const desde = entity === this.FECHA.CREACION_DESDE || entity === this.FECHA.TEMPORAL_DESDE;
    if (entity === this.FECHA.CREACION_DESDE || entity === this.FECHA.CREACION_HASTA) {
      const dates = this.normalizeDate(desde, desde ? e : this.filters.fechaCreacion.desde, desde ? this.filters.fechaCreacion.hasta : e);
      this.filters.fechaCreacion.desde = dates.desde;
      this.filters.fechaCreacion.hasta = dates.hasta;
      this.filters.marcaTemporal.desde = null;
      this.filters.marcaTemporal.hasta = null;
    } else if (entity === this.FECHA.TEMPORAL_DESDE || entity === this.FECHA.TEMPORAL_HASTA) {
      const dates = this.normalizeDate(desde, desde ? e : this.filters.marcaTemporal.desde, desde ? this.filters.marcaTemporal.hasta : e);
      this.filters.marcaTemporal.desde = dates.desde;
      this.filters.marcaTemporal.hasta = dates.hasta;
      this.filters.fechaCreacion.desde = null;
      this.filters.fechaCreacion.hasta = null;
    }
  }

  normalizeDate(isDesde, desde, hasta) {
    let retDesde = desde != null ? moment(desde).startOf('day').toDate() : null;
    let retHasta = hasta != null ? moment(hasta).endOf('day').toDate() : null;
    if (isDesde) {
      if (hasta === null) {
        retHasta = moment().endOf('day').toDate();
      } else {
        if (retDesde > hasta) {
          retHasta = moment(retDesde).endOf('day').toDate();
        }
      }
    } else {
      if (desde === null) {
        retDesde = moment(retHasta).startOf('day').toDate();
      } else {
        if (retHasta < desde) {
          retDesde = moment(retHasta).startOf('day').toDate();
        }
      }
    }
    return {desde: retDesde, hasta: retHasta};
  }

  setupChipsFilters(type) {
    setTimeout(() => {
      this.chipFilters.forEach(filter => {
        if (filter.Type === type) {

          if (type === this.CHIP_TYPES.PRODUCTO) {
            filter.optionsChange(this.productoOptions.map(x => {
              return {ID: x.ID, ItemLabel: x.Producto};
            }), this.filters.productos);
          } else if (type === this.CHIP_TYPES.ZONA) {
            filter.optionsChange(this.zonasOptions.map(x => {
              return {ID: x.ID, ItemLabel: x.Categoria};
            }), this.filters.zonas);
          }
        }
      });
    }, 300);
  }

  clearFilters() {
    this.negociosService.resetKanbanFilter();
    this.filters = this.negociosService.negocioKanbanFilter;
    this.chipFilters.forEach(x => {
      x.unselectAllOptions();
    });
    this.clienteAutocomplete.selectedCuentas = [];
    this.acopioAutocomplete.selectedAcopios = [];
    this.colaboradoresAutocomplete.forEach(x => {
      x.selectedColaboradores = [];
    });
    this.applyFilters();
  }

  chipFilterChanged(e) {
    if (e.Type === this.CHIP_TYPES.PRODUCTO) {
      this.filters.productos = e.SelectedIds;
    } else if (e.Type === this.CHIP_TYPES.ZONA) {
      this.filters.zonas = e.SelectedIds;
    }
  }

  applyFilters() {
    this.searchKanban.emit({});
  }

  setupNegocioOptions() {
    this.negocioOptions = [];
    this.negocioOptions.push(
      {label: this.NEGOCIO_TYPE_DISPO, value: 'DISPONIBLE'},
      {label: this.NEGOCIO_TYPE_FORWARD, value: 'FORWARD'}
    );
    if (this.pagoDiferidoExists) {
      this.negocioOptions.push(
        {label: 'Pago Diferido', value: 'PAGO_DIFERIDO'},
      );
    }
    if (this.filters.negocio !== null) {
      this.changedNegocio({value: this.filters.negocio});
    }
  }

  changedNegocio(e) {
    // editar la moneda
    this.filters.negocio = e.value;
    if (e.value === 'DISPONIBLE') {
      this.currentEntregaOptions = this.entregaOptions.filter(x => x.EsPosicion === false).map(x => ({
        ID_POS: x.ID,
        Posicion: x.Entrega
      }));
      if (!this.pagoDiferidoExists) {
        this.currentEntregaOptions = this.currentEntregaOptions.filter(x => x.ID_POS !== 4);
      }
    } else if (e.value === 'FORWARD') {
      if (this.pagoDiferidoExists) {
        this.currentEntregaOptions = this.posicionOptions.filter(x => x.Tipo === 'Posicion' && x.Entrega_Id === 3);
      } else {
        this.currentEntregaOptions = this.posicionOptions.filter(x => x.Tipo === 'Posicion');
        this.currentEntregaOptions = this.currentEntregaOptions.filter(x => x.Posicion !== 'undefined-undefined');
      }
    } else if (e.value === 'PAGO_DIFERIDO') {
      this.currentEntregaOptions = this.posicionOptions.filter(x => x.Tipo === 'Posicion' && x.Entrega_Id === 4);
      // this.currentMonedaOptions = this.monedaOptions.filter(x => x.ID === 1);
    } else if (e.value === null) {
      this.filters.entrega = null;
    }
  }

  clienteSelected() {
    this.filters.clientes = this.clienteAutocomplete.selectedCuentas;
  }

  acopioSelected() {
    this.filters.acopios = this.acopioAutocomplete.selectedAcopios;
  }

  colaboradoresSelected(type) {
    this.colaboradoresAutocomplete.forEach(col => {
      if (col.type === type) {
        if (type === 'resp') {
          this.filters.responsables = col.selectedColaboradores;
        } else if (type === 'auto') {
          this.filters.autorizantes = col.selectedColaboradores;
        }
      }
    });
  }

  fillClienteFilter() {
    this.clienteAutocomplete.selectedCuentas = this.filters.clientes;
  }

  fillAcopioFilter() {
    this.acopioAutocomplete.selectedAcopios = this.filters.acopios;
  }

  fillColaboradoresFilter(type) {
    this.colaboradoresAutocomplete.forEach(col => {
      if (col && col.type === type) {
        if (type === 'resp') {
          col.selectedColaboradores = this.filters.responsables;
        } else if (type === 'auto') {
          col.selectedColaboradores = this.filters.autorizantes;
        }
      }
    });
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/negocios/negocios-kanban/negocios-kanban-filters/negocios-kanban-filters.component.ts